<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">
          Update revised scheme deadline
        </h1>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <b-field label="Revised Scheme Deadline">
              <b-datepicker
                name="planned_scheme_deadline"
                required
                v-model="planned_scheme_deadline"
                :date-formatter="dateFormatter"
                icon="calendar-today"
                trap-focus
                data-cy="revised-scheme-deadline"
              >
              </b-datepicker>
            </b-field>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button
          slot="right"
          native-type="submit"
          type="is-primary"
          v-on:click="submit"
        >
          Save
        </b-button>
        <b-button slot="right" type="is-danger" @click="cancel">
          Abort
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>
<script>
import ReportingTrackerDataService from "../../services/ReportingTrackerDataService";
// @group Reporting Tracker
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    checkedRows: {
      type: Array,
      default: null
    },
    isAllChecked: {
      type: Boolean,
      default: false
    },
    filters: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      planned_scheme_deadline: null,
      isModalActive: false,
      reportingTrackerService: new ReportingTrackerDataService()
    };
  },

  methods: {
    queryFormat(query) {
      const items = query.split("&");
      const map = {};
      items.filter(function(item) {
        if (item.length > 0) {
          const i = item.split("=");
          if (map[i[0]]) {
            map[i[0]].push(i[1]);
          } else {
            map[i[0]] = [i[1]];
          }
        }
      });
      return map;
    },
    handleApiError(reason) {
      console.log(reason.response.data);
    },
    dateFormatter(dt) {
      if (dt != null) {
        return dt.toLocaleDateString("fr-CA");
      }
      return dt;
    },
    submit() {
      try {
        this.reportingTrackerService
          .reviseSchemeDeadline(
            this.checkedRows.map(records => records.id),
            this.planned_scheme_deadline,
            this.isAllChecked,
            this.filters
          )
          .subscribe(response => {
            if (response["success"]) {
              this.$buefy.dialog.alert({
                title: "Success",
                message: response["success"]
              });
              this.$emit(
                "confirm",
                this.dateFormatter(this.planned_scheme_deadline)
              );

              this.planned_scheme_deadline = null;
            } else if (response["error"]) {
              this.$buefy.dialog.alert({
                title: "Error",
                message: response["error"]
              });
              return false;
            }
          }, this.handleApiError);
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Nothing to Update!",
          message: e.message
        });
      }
    },
    cancel() {
      this.$emit("cancel");
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.$emit("cancel");
      }
    }
  }
};
</script>
